<template>
    <div class="content">
      <div class="container-fluid">
          <div class="row">
              <div class="col-md-12">
                <div class="nav-bar box-horizontal mb-0">
                <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                  <div class="flex-1">
                    <h3 class="m-0">Total Tugas Admin</h3>
                    <p class="mb-0">Kumpulan Total tugas yang telah dikerjakan teknisi :)</p>
                  </div>
                </div>
                <div class="mt-3">
                    <button @click="data.tanggalBox = true"  class="btn btn-info" v-show="!data.tanggalBox">Filter Tanggal</button>
                    <button @click="data.bulanBox = true"  class="btn btn-info" v-show="!data.bulanBox">Filter Bulan</button>
                </div>
                <div class="card mt-3">
                  <div class="card-body">
                      <div class="col-md-3" v-show="data.bulanBox">
                        <label for="tanggal" class="text-dark">Pilih Bulan</label>
                        <div class="box-horizontal">
                            <select v-model="data.bulan" class="form-control">
                                <option value="" disabled>Pilih Bulan</option>
                                <option value="01">Januari</option>
                                <option value="02">Februari</option>
                                <option value="03">Maret</option>
                                <option value="04">April</option>
                                <option value="05">Mei</option>
                                <option value="06">Juni</option>
                                <option value="07">Juli</option>
                                <option value="08">Agustus</option>
                                <option value="09">September</option>
                                <option value="10">Oktober</option>
                                <option value="11">November</option>
                                <option value="12">Desember</option>
                            </select>
                            <select v-model="data.tahun" class="form-control">
                                <option value="" disabled>Pilih Tahun</option>
                                <option value="2024">2024</option>
                                <option value="2025">2025</option>
                                <option value="2026">2026</option>
                            </select>
                            <button class="btn btn-info btn-sm" type="button" style="height: 30px;" @click="theGet.datae()">Cari</button>
                        </div>
                      </div>

                      <div class="col-md-3" v-show="data.tanggalBox">
                        <label for="tanggal" class="text-dark">Pilih Tanggal</label>
                        <div class="box-horizontal">
                          <vuejs-datepicker :format="theGet.customFormatter" id="tanggal" type="text" placeholder="Pilih Tanggal..." v-model="data.tanggal" style="width: 100%"></vuejs-datepicker>
                          <button class="btn btn-info btn-sm" type="button" style="height: 30px;" @click="theGet.datae()">Cari</button>
                        </div>
                      </div>

                        <div class="col-md-12">
                            <h4>Filter by Tanggal {{ data.tanggalText }}</h4>
                        </div>

                      <div class="table-responsive">
                      <table class="table">
                          <thead class=" text-info">
                          <th width="60px">No</th>
                          <th>Nama</th>
                          <th>Total</th>
                          </thead>
                          <!-- LOADING -->
                          <tbody v-show="data.loading">
                          <tr>
                              <td colspan="8"><Loading></Loading></td>
                          </tr>
                          <tr>
                              <td colspan="8"><Loading></Loading></td>
                          </tr>
                          <tr>
                              <td colspan="8"><Loading></Loading></td>
                          </tr>
                          </tbody>
                          <!-- DATA -->
                          <tbody v-show="!data.loading">
                            <tr v-for="(u, index) in theGet.data.List">
                                <td>{{ index+1 }}</td>
                                <td>
                                    {{u.nama}}
                                </td>
                                <td>
                                    {{u.jumlah}}
                                </td>
                            </tr>
                            <!-- NULL -->
                            <tr v-if="theGet.data.List == null">
                                <td></td>
                                <td>Tidak ada Data </td>
                            </tr>
                          </tbody>
                      </table>
                      </div>
                  </div>
                  </div>
              </div>
              
          </div>
      </div>


    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import vuejsDatepicker from 'vuejs-datepicker'

export default {
name: 'Beranda',
  components: { 
  vuejsDatepicker,
  "Loading" : Loading
  }, 
setup() {
  const data = reactive({
    loading: true,
    // modal detail
    modalDetail: false,
    // rincian detail teknisi & pelanggan
    tanggal: null,
    tanggalBox: false,
    tanggalText: '',
    bulanBox: false,
    bulan: '',
    tahun: ''
  })

  const theGet = {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    data: reactive({
      List: [],
      Teknisi: [],
      Total: "0",
    }),
    datae() {
        data.loading = true;
        setTimeout(function() {
            theGet.dataeNow();
        }, 1000);
    },
    dataeNow() {
        
      var datax = {
        token: 'TangTung '+sessionStorage.getItem('myToken')
      };

      if(data.tanggal != null) {
        datax["tanggal"] = this.customFormatter(data.tanggal)
      }

      if(data.bulan != "") {
        if(data.tahun != "") {
            datax["bulan"] = data.tahun+"-"+data.bulan
        } else {
            alert("Pilih tahun juga")
        }
      }

      //console.log(JSON.stringify(datax))
  
      var apiUrl = inter.TugasTotal();
      myGlobal.call(datax,apiUrl).then(x => {
          myGlobal.loger(x);

          data.loading = false;
        
          if (x.status == true) {
            this.data.List = x.data.list;
            data.tanggalText = myGlobal.tglIndo(x.data.tanggal)
          } else {
            theGet.data.List = null;
          }
      })

    }
  }
  return {
    data,
    myGlobal,
    theGet
  }
},
mounted () {
    document.title = "Total Tugas";

    this.data.namaQ = sessionStorage.getItem('admin');

    this.theGet.datae();
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
font-weight: normal;
}
ul {
list-style-type: none;
padding: 0;
}
li {
display: inline-block;
margin: 0 10px;
}
a {
color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/tugas/total.vue